var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 647,
    height: 647,
    viewBox: "0 0 647 647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3,.cls-5,.cls-6,.cls-7{mix-blend-mode:lighten;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{mix-blend-mode:screen;}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:#404041;}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.5,
    y1: 322.07,
    x2: 645.64,
    y2: 322.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b0e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#02afe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#09ade1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#14aad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#25a5ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3b9ebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5796ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#768d97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#83898e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#9d8377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b87e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ce794b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#df753b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ea7331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f1712b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f37129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 323.57,
    x2: 647.14,
    y2: 323.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c0f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#02c0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#09beec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#14bce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#25b9d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3bb5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#57b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#77aa97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#9ba47b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#b49f68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c09a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d39145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#e28a34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ec8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f28322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f48220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 516.09,
    y1: 515.37,
    x2: -317.03,
    y2: -317.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6921e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 516.62,
    y1: 515.86,
    x2: -316.5,
    y2: -317.27,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 516.52,
    y1: 516.14,
    x2: -316.61,
    y2: -316.99,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 407.59,
    y1: 374.19,
    x2: 242.09,
    y2: 156.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05a28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 332.96,
    y1: 430.98,
    x2: 167.46,
    y2: 213.52,
    xlinkHref: "#linear-gradient-6"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Datassential") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M642.07,225,484,613.84a48.76,48.76,0,0,1-63.34,26.73L31.79,482.5A48.76,48.76,0,0,1,5.06,419.16L163.13,30.29A48.76,48.76,0,0,1,226.47,3.56L615.35,161.63A48.76,48.76,0,0,1,642.07,225Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M617.45,480.13,230.7,643.33A48.76,48.76,0,0,1,167,617.45L3.8,230.7A48.76,48.76,0,0,1,29.69,167L416.44,3.8a48.76,48.76,0,0,1,63.69,25.89L643.33,416.44A48.76,48.76,0,0,1,617.45,480.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M290.19,590.46,58,358.22a48.76,48.76,0,0,1,0-68.75L290.19,57.23a48.76,48.76,0,0,1,68.75,0L591.18,289.47a48.76,48.76,0,0,1,0,68.75L358.94,590.46A48.76,48.76,0,0,1,290.19,590.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290.73,590.95,58.49,358.71a48.76,48.76,0,0,1,0-68.75L290.73,57.72a48.76,48.76,0,0,1,68.75,0L591.72,290a48.76,48.76,0,0,1,0,68.75L359.48,590.95A48.76,48.76,0,0,1,290.73,590.95Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M290.62,591.23,58.38,359a48.76,48.76,0,0,1,0-68.75L290.62,58a48.76,48.76,0,0,1,68.75,0L591.61,290.24a48.76,48.76,0,0,1,0,68.75L359.37,591.23A48.76,48.76,0,0,1,290.62,591.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M148.23,329.66a29,29,0,0,1-1.7,10.22,22,22,0,0,1-4.78,7.72,20.69,20.69,0,0,1-7.39,4.88,25.73,25.73,0,0,1-9.51,1.7H106.95v-49h17.91a25.73,25.73,0,0,1,9.51,1.7,20.69,20.69,0,0,1,7.39,4.88,22,22,0,0,1,4.78,7.72A28.88,28.88,0,0,1,148.23,329.66Zm-3.67,0a27.34,27.34,0,0,0-1.42-9.14,19.1,19.1,0,0,0-4-6.79,17.15,17.15,0,0,0-6.24-4.23,21.42,21.42,0,0,0-8-1.46H110.51V351.3h14.34a21.43,21.43,0,0,0,8-1.45,17.19,17.19,0,0,0,6.24-4.23,19.1,19.1,0,0,0,4-6.79A27.46,27.46,0,0,0,144.56,329.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.37,354.18h-2.74a1.2,1.2,0,0,1-.8-.26,1.75,1.75,0,0,1-.49-.67L184.6,339H160.53l-5.75,14.24a1.51,1.51,0,0,1-.49.66,1.29,1.29,0,0,1-.83.28h-2.7l20.05-49h3.5Zm-10.84-17.8-10-24.77a24.43,24.43,0,0,1-1-2.91q-.21.83-.45,1.58a13.67,13.67,0,0,1-.52,1.37l-10,24.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228.14,308.18H210.92v46h-3.57v-46H190v-3h38.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M267.45,354.18h-2.74a1.2,1.2,0,0,1-.8-.26,1.75,1.75,0,0,1-.49-.67L257.68,339H233.61l-5.75,14.24a1.51,1.51,0,0,1-.49.66,1.29,1.29,0,0,1-.83.28h-2.7l20.05-49h3.5Zm-10.84-17.8-10-24.77a24.41,24.41,0,0,1-1-2.91q-.21.83-.45,1.58a13.7,13.7,0,0,1-.52,1.37l-10,24.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M298.69,312.3a2.54,2.54,0,0,1-.67.78,1.47,1.47,0,0,1-.88.26,2.46,2.46,0,0,1-1.39-.59q-.8-.59-2-1.3a16.12,16.12,0,0,0-2.88-1.3,12.41,12.41,0,0,0-4.07-.59,11.9,11.9,0,0,0-4,.61,8.51,8.51,0,0,0-2.88,1.65,6.77,6.77,0,0,0-1.75,2.44,7.77,7.77,0,0,0-.59,3,5.6,5.6,0,0,0,1,3.45,8.79,8.79,0,0,0,2.7,2.34,20.67,20.67,0,0,0,3.81,1.68l4.37,1.47q2.23.76,4.36,1.72a15.35,15.35,0,0,1,3.81,2.41,11,11,0,0,1,2.7,3.57,11.89,11.89,0,0,1,1,5.2,16.75,16.75,0,0,1-1.11,6.11,14.13,14.13,0,0,1-3.24,5,15.08,15.08,0,0,1-5.23,3.32,19.23,19.23,0,0,1-7,1.22A21.5,21.5,0,0,1,276,353a20.64,20.64,0,0,1-6.75-4.73l1.94-3.19a2.61,2.61,0,0,1,.68-.64,1.59,1.59,0,0,1,.88-.26,2,2,0,0,1,1,.36q.57.37,1.3.92c.49.37,1,.78,1.66,1.21a13.6,13.6,0,0,0,2.13,1.21,14.56,14.56,0,0,0,2.72.92,14.88,14.88,0,0,0,3.43.36,12.79,12.79,0,0,0,4.26-.66,9,9,0,0,0,3.17-1.85,8,8,0,0,0,2-2.86,9.55,9.55,0,0,0,.69-3.7,6.23,6.23,0,0,0-1-3.69,8.5,8.5,0,0,0-2.68-2.41,18.52,18.52,0,0,0-3.81-1.65L283.24,331a46.43,46.43,0,0,1-4.36-1.65,14.09,14.09,0,0,1-3.81-2.42,11.13,11.13,0,0,1-2.68-3.72,14.26,14.26,0,0,1,0-10.62,13,13,0,0,1,3-4.36,14.6,14.6,0,0,1,4.81-3,17.61,17.61,0,0,1,6.56-1.14,20.89,20.89,0,0,1,7.57,1.32,17.91,17.91,0,0,1,6,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M334.88,312.3a2.59,2.59,0,0,1-.67.78,1.48,1.48,0,0,1-.89.26,2.45,2.45,0,0,1-1.38-.59c-.53-.39-1.2-.82-2-1.3a16.18,16.18,0,0,0-2.87-1.3,12.43,12.43,0,0,0-4.07-.59,11.93,11.93,0,0,0-4,.61,8.46,8.46,0,0,0-2.87,1.65,6.7,6.7,0,0,0-1.75,2.44,7.72,7.72,0,0,0-.59,3,5.6,5.6,0,0,0,1,3.45,8.79,8.79,0,0,0,2.7,2.34,20.48,20.48,0,0,0,3.81,1.68l4.36,1.47q2.23.76,4.37,1.72a15.34,15.34,0,0,1,3.81,2.41,11,11,0,0,1,2.7,3.57,11.89,11.89,0,0,1,1,5.2,16.75,16.75,0,0,1-1.11,6.11,14.09,14.09,0,0,1-3.24,5,15.08,15.08,0,0,1-5.23,3.32,19.21,19.21,0,0,1-7,1.22,21.47,21.47,0,0,1-8.8-1.75,20.61,20.61,0,0,1-6.75-4.73l1.94-3.19a2.55,2.55,0,0,1,.67-.64,1.6,1.6,0,0,1,.88-.26,2,2,0,0,1,1,.36q.57.37,1.3.92c.48.37,1,.78,1.66,1.21a13.63,13.63,0,0,0,2.13,1.21,14.52,14.52,0,0,0,2.72.92,14.91,14.91,0,0,0,3.43.36,12.77,12.77,0,0,0,4.26-.66,9,9,0,0,0,3.17-1.85,8,8,0,0,0,2-2.86,9.49,9.49,0,0,0,.69-3.7,6.23,6.23,0,0,0-1-3.69,8.54,8.54,0,0,0-2.69-2.41,18.52,18.52,0,0,0-3.81-1.65L319.44,331a46.5,46.5,0,0,1-4.37-1.65,14.08,14.08,0,0,1-3.81-2.42,11.09,11.09,0,0,1-2.69-3.72,14.3,14.3,0,0,1,0-10.62,13,13,0,0,1,3-4.36,14.56,14.56,0,0,1,4.81-3,17.6,17.6,0,0,1,6.56-1.14,20.9,20.9,0,0,1,7.57,1.32,17.87,17.87,0,0,1,6,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M376.31,348.7l0,5.47H345.69V304.54h30.58V310H352.41V326.5h19.33v5.27H352.41V348.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M424.52,304.54v49.63h-3.36a2.87,2.87,0,0,1-1.33-.28,3.29,3.29,0,0,1-1.06-.93l-28.71-37.41c0,.58.08,1.14.1,1.7s0,1.07,0,1.56v35.36h-5.89V304.54h3.47a4.92,4.92,0,0,1,.76.05,2.06,2.06,0,0,1,.55.17,2.18,2.18,0,0,1,.49.35,5.29,5.29,0,0,1,.52.57l28.71,37.37q-.07-.9-.12-1.75c0-.56-.05-1.1-.05-1.61V304.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M469.38,310.19H453.31v44h-6.69v-44h-16.1v-5.65h38.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M482.05,354.18h-6.72V304.54h6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M533.69,354.18H528.5a2.24,2.24,0,0,1-1.46-.45,2.76,2.76,0,0,1-.83-1.14l-4.64-12H499.3l-4.64,12a2.46,2.46,0,0,1-.8,1.11,2.22,2.22,0,0,1-1.46.49h-5.2l19.85-49.63h6.79Zm-14-18.43-7.79-20.19c-.23-.6-.47-1.3-.73-2.09s-.5-1.65-.73-2.55A38.1,38.1,0,0,1,509,315.6l-7.79,20.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M567,348.53v5.64H538.85V304.54h6.69v44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M222.82,273.69V190.76H313q26.54,0,48.59,8.78a105,105,0,0,1,37.91,25.54q15.86,16.76,24.54,41.21c.86,2.41,1.63,4.89,2.36,7.4h11.73q-1.52-5.43-3.41-10.59-9.58-26-26.94-44.1a116.28,116.28,0,0,0-41.51-27.64q-24.15-9.58-53.28-9.58H211.84v91.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M424.55,376.33c-.17.5-.32,1-.49,1.51q-8.68,24.45-24.54,41.21a105,105,0,0,1-37.91,25.54q-22.05,8.78-48.59,8.78H222.82v-77h-11v86H313q29.13,0,53.28-9.58a116.24,116.24,0,0,0,41.51-27.64q17.36-18.06,26.94-44.1c.57-1.55,1.1-3.12,1.62-4.7Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDs);
export default __webpack_public_path__ + "static/media/logo_ds.629f1e819917363cc4fe832a99120bb4.svg";
export { ForwardRef as ReactComponent };